<template>
  <div class="d-flex align-center">
    <v-menu bottom rounded offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-badge
            :value="notificationsCount > 0"
            :content="notificationsCount"
            color="red"
            overlap
          >
            <v-avatar title="Notificações" color="white" size="35px">
              <span class="font-weight-black" style="color: #2e66b7">{{
                me.name
                  ? me.name.charAt(0)
                  : me.providers[0].trade_name.charAt(0)
              }}</span>
            </v-avatar>
          </v-badge>
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <scroll class="grid-notification" v-if="notificationsCount > 0">
            <v-skeleton-loader
              transition="scale-transition"
              height="94"
              type="list-item-two-line"
            >
              <v-list-item-content class="justify-center">
                <div class="mx-auto text-center">
                  <div
                    class="notification"
                    v-for="notification in notifications"
                    :key="notification.processo"
                    @click="clickNotification(notification)"
                  >
                    <v-icon x-large :class="getCssClassFor(notification)">
                      {{ notification.icone }}
                    </v-icon>

                    <div class="content">
                      <p :class="getCssClassFor(notification)">
                        {{ notification.nm_etapa }}
                      </p>
                      <p :class="getCssClassFor(notification)">
                        {{ notification.mensagem }}
                      </p>
                    </div>
                  </div>
                </div>
              </v-list-item-content>
            </v-skeleton-loader>
          </scroll>
          <p
            v-else
            style="font-size: 1.1rem;"
            class="text-right text--black ma-1 pa-3"
          >
            Sem notificações
          </p>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import _ from "lodash";
import JWT from "../../api/jwt";
import { mapActions, mapGetters } from "vuex";
import scroll from "../UI/BaseScroll";
export default {
  components: {
    scroll
  },
  data() {
    return {
      notificationsCount: 0
    };
  },

  computed: {
    ...mapGetters({
      me: "$_auth/me",
      notifications: "$_auth/notifications",
      meInGFS: "$_auth/meInGfs"
    })
  },

  methods: {
    ...mapActions({
      getNotifications: "$_auth/getNotifications"
    }),

    getCssClassFor(notification) {
      if (notification.atrasado) return "atrasado";
      return "no-prazo";
    },

    async clickNotification(notification) {
      if (!this.me.tokenGfs) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Não foi possível acessar o processo no momento. Por favor, tente novamente.`,
          type: "error",
          title: "Error!",
          timeout: 8000
        });
        return false;
      }
      let url = `${process.env.VUE_APP_GFS_URL}processos/${
        notification.processo
      }/editar?token_pfo=${JWT.getToken()}&token_gfs=${
        this.me.tokenGfs
      }&back=${this.$route.path.slice(1)}`;
      window.location.replace(url);
    },

    verifyAuth(me) {
      if (_.hasIn(me, "id") && !this.me.password_reset) return true;
      else return false;
    }
  },

  watch: {
    notifications(newVal) {
      this.notificationsCount = newVal.length;
    }
  },

  async mounted() {
    if (this.$can("edit", "process.index")) {
      await this.getNotifications();

      var interval = setInterval(() => {
        if (!this.verifyAuth(this.me)) clearInterval(interval);
        else this.getNotifications();
      }, 250000);
    }
  }
};
</script>
<style lang="scss" scoped>
.notification {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  white-space: nowrap;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    background-color: #eee;
  }

  p {
    margin: 1px 0;
    padding: 2px;
    text-align: left;
    font-size: 0.85rem;
  }
}

.grid-notification {
  max-height: 280px !important;
}

.atrasado {
  color: #ea6355 !important;
}

.no-prazo {
  color: #039b4a !important;
}

.v-icon {
  margin: 3px;
  padding: 10px;
}

.v-card__text {
  padding: 3px !important;
}
</style>
